import './milestones-videos.scss';
import Switcher from '../../../modules/switcher/switcher';

const switcher = new Switcher();
switcher.init();

